import { createFileRoute, useCanGoBack } from '@tanstack/react-router'

import { Authentication } from '@/rbac'
import { useCallStatesStore } from '@/routes/arc/-features/calling/stores/callStates.store.ts'
import { useNavigationBlocker } from '@/routes/arc/-hooks/useNavigationBlocker.ts'
import { useOperatorLocalStatus } from '@/routes/arc/-stores/operator.store.ts'
import { arcProfileSearchSchema } from '@/routes/arc/-types/arc-search.ts'
import AssociatedNotificationCall from '@/routes/arc/profile/-associated/notification-call/AssociatedNotificationCall.tsx'
import AssociatedTempNotes from '@/routes/arc/profile/-associated/temp-notes/AssociatedTempNotes.tsx'
import CallingPanel from '@/routes/arc/profile/-calling-panel/CallingPanel.tsx'
import Profile from '@/routes/arc/profile/-Profile.tsx'
import { useProfileAssociation } from '@/routes/arc/profile/-stores/association.store.ts'
import { ProfileAssociationBridge } from '@/routes/arc/profile/-stores/ProfileAssociationBridge.tsx'

export const Route = createFileRoute('/arc/profile')({
  component: ProfilePage,
  validateSearch: arcProfileSearchSchema,
})

function ProfilePage() {
  const callGoback = useCanGoBack()
  const association = useProfileAssociation()
  const hasCalling = useCallStatesStore((s) => s.callStates.length > 0)
  const operatorStatus = useOperatorLocalStatus()
  const shouldShowCallingUi = operatorStatus === 'CALLING' || hasCalling

  // Block navigation while the operator is in a CALLING state.
  // TODO verify this works as expected
  useNavigationBlocker(operatorStatus === 'CALLING')

  if (shouldShowCallingUi) {
    return (
      <div className={'flex min-h-0 flex-1'}>
        <ProfileAssociationBridge />
        <div className={'fit-col'}>
          <div className={'fit-col p-2.5'}>
            <AssociatedTempNotes />
            <AssociatedNotificationCall />
            <Authentication require={['arc:profile']} failMode={'empty'}>
              <Profile hasBack={false} showEdit={true} showSwitch={true} />
            </Authentication>
          </div>
        </div>
        <div className={'fit-col max-w-90 min-w-90'}>
          <div className={'flex h-full flex-col gap-2.5 py-2.5 pr-2'}>
            <CallingPanel association={association} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={'fit-col p-2.5'}>
      <ProfileAssociationBridge />
      <Authentication require={['arc:profile']} failMode={'empty'}>
        <Profile key={'scheme-page'} hasBack={callGoback} showEdit={true} showSwitch={false} />
      </Authentication>
    </div>
  )
}
